<template>
  <div :class="productFlag == 7?'train_header':'study_header'">
    <div class="logo">
      <img src="/static/images/logo_new.png" alt="">
    </div>
    <div class="course_title">
      <p :title="courseName">{{courseName}}</p>
    </div>
    <div class="class_name" :title="$route.query.className">{{$route.query.className?'班级：':''}}{{$route.query.className}}</div>
    <div class="login-user">
      <el-dropdown @command="handleCommand" :show-timeout="0">
        <div class="user-name el-dropdown-link">
            <div class="imgBox">
              <img :src="imgUrl">
            </div>
            <div class="login-name" :title="name">{{name}}</div>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="d">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="tab_list" v-if="isPreview">
      <ul>
        <li v-for="(item,index) in routerarr" :key="index" :class="{active:index===curId}" @click="switchTab(item,index)">{{item.name}}</li>
      </ul>
    </div>
    <div class="tab_list_preview" v-if="!isPreview">课件</div>
  </div>
</template>
<script>
export default {
  data(){
    return {
      routerQuery: this.$route.query,
      // imgUrl:'../../../static/images/homepage/headPic.png',
      imgUrl:'../../../../static/images/hed0.png',
      name:'',
      curId: 0,
      courseName: '',
      isPreview: true,
      courseType: '',
      productFlag: sessionStorage.getItem("productFlag")
    }
  },
  props:{
    routerarr: {
      type: Array,
      default: []
    }
  },
  watch: {
    'routerarr': function(val){
      val.forEach((v,i)=>{
        if(this.$route.path.split('/')[2] == v.path.split('/')[2]){
          this.curId = i
        }
      })
    }
  },
  mounted() {
    console.log('--query--', this.routerQuery)
    // document.getElementsByTagName("title")[0].innerText = '学习中心';
    this.courseName = this.$route.query.courseName
  },
  created() {
    this.name = this.$store.state.loginName? this.$store.state.loginName : sessionStorage.getItem('loginName');
  },
  methods: {
    handleCommand(command){
      if(command == 'd'){
        this.$logOut()
      }
    },
    switchTab(item,index){
      console.log(item)
      this.curId = index
      let that = this
      let classId = this.$route.query.classId;
      let courseType = sessionStorage.getItem('courseType')
      if(item.path == '/switch/courseware'){
        if(sessionStorage.getItem('isPreview')=='false'){
          this.$router.push({
            path:'/switch/courseware/courseDetail',
            query: this.routerQuery
          })
        }else{
          this.$router.push({
            path:'/switch/courseware/preview',
            query: {
              id: this.$route.query.id,
              subjectId: this.$route.query.subjectId,
              courseName: this.$route.query.courseName
            }
          })
        }
      }else if(item.path == '/switch/statistics'){
        let userType = sessionStorage.getItem('userType')
        if(userType==2||userType==3){
          if (courseType==1) {
            this.$router.push({
              path: '/switch/statistics/studentTheory',
              query: {
                id: that.$route.query.id,
                classId: that.$route.query.classId,
                className: that.$route.query.className
              }
            })
          }else if (courseType==2) {
            this.$router.push({
              path: '/switch/statistics/sudentTraining',
              query: {
                id: that.$route.query.id,
                classId: that.$route.query.classId,
                className: that.$route.query.className,
                type: that.$route.query.type
              }
            })
          }else{
            let url = ''
            if(this.productFlag==7){
              url = '/switch/statistics/studentcComprehensive2'
            }else{
              url = '/switch/statistics/studentcComprehensive'
            }
            this.$router.push({
              path: url,
              query: {
                id: that.$route.query.id,
                classId: that.$route.query.classId,
                className: that.$route.query.className,
                type: that.$route.query.type
              }
            })
          }
        }else{
          if (courseType==1) {
            this.$router.push({
              path: '/switch/statistics/teacherTheory',
              query: {
                id: that.$route.query.id,
                classId: that.$route.query.classId,
                className: that.$route.query.className
              }
            })
          }else if (courseType==2) {
            this.$router.push({
              path: '/switch/statistics/teacherTraining',
              query: {
                id: that.$route.query.id,
                classId: that.$route.query.classId,
                className: that.$route.query.className,
                type: that.$route.query.type
              }
            })
          }else{
            let url = ''
            if(this.productFlag==7){
              url = '/switch/statistics/comprehensiveTraining2'
            }else{
              url = '/switch/statistics/comprehensiveTraining'
            }
            this.$router.push({
              path: url,
              query: {
                id: that.$route.query.id,
                classId: that.$route.query.classId,
                className: that.$route.query.className,
                type: that.$route.query.type
              }
            })
          }
        }
      }else{
        this.$router.push({
          path: item.path,
          query: {
            id: this.$route.query.id,
            classId: this.$route.query.classId,
            className: this.$route.query.className,
            subjectId: this.$route.query.subjectId,
          }
        })
      }
      // {path:item.path,query:{id:$route.query.id,classId:$route.query.classId,className:$route.query.className,subjectId:$route.query.subjectId}}
      return
      if(item.path == '/switch/courseware'){
        if (classId && (classId != null || classId != undefined)) {
          if (courseType && (courseType != null || courseType != undefined)) {
            this.$router.push({
              path:'/switch/courseware/courseDetail',
              query: this.routerQuery
            })
          }else{
            this.$router.push({
              path:'/switch/courseware/courseDetail',
              query: this.routerQuery
            })
          }
        }else{
          this.$router.push({
            path:'/switch/courseware/preview',
            query: {
              id: this.$route.query.id
            }
          })
        }
      }else if(item.path == '/switch/statistics'){
        let userType = sessionStorage.getItem('userType')
        if(userType==2||userType==3){
          if (courseType==1) {
            this.$router.push({
              path: '/switch/statistics/studentTheory',
              query: {
                id: that.$route.query.id,
                classId: that.$route.query.classId,
                className: that.$route.query.className
              }
            })
          }else if (courseType==2) {
            this.$router.push({
              path: '/switch/statistics/sudentTraining',
              query: {
                id: that.$route.query.id,
                classId: that.$route.query.classId,
                className: that.$route.query.className,
                type: that.$route.query.type
              }
            })
          }else{
            this.$router.push({
              path: '/switch/statistics/studentcComprehensive',
              query: {
                id: that.$route.query.id,
                classId: that.$route.query.classId,
                className: that.$route.query.className,
                type: that.$route.query.type
              }
            })
          }
        }else{
          if (courseType==1) {
            this.$router.push({
              path: '/switch/statistics/teacherTheory',
              query: {
                id: that.$route.query.id,
                classId: that.$route.query.classId,
                className: that.$route.query.className
              }
            })
          }else if (courseType==2) {
            this.$router.push({
              path: '/switch/statistics/teacherTraining',
              query: {
                id: that.$route.query.id,
                classId: that.$route.query.classId,
                className: that.$route.query.className,
                type: that.$route.query.type
              }
            })
          }else{
            this.$router.push({
              path: '/switch/statistics/comprehensiveTraining',
              query: {
                id: that.$route.query.id,
                classId: that.$route.query.classId,
                className: that.$route.query.className,
                type: that.$route.query.type
              }
            })
          }
        }
      }
    },
  },
}
</script>
<style lang="scss">
  .train_header {
    background: #1A4ABA;
  }
  .study_header {
    background: #1D70E2;
  }
  .train_header,.study_header{
    height: 56px;
    width: 100%;
    .logo{
      width: 280px;
      float: left;
      img{
        height: 38px;
        margin: 9px 0 0 16px
      }
    }
    .course_title{
      float: left;
      p{
        max-width: 250px;
        overflow: hidden;
        line-height: 56px;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size:14px;
        font-weight:400;
        color:rgba(255,255,255,1);
      }
    }
    .class_name {
    	float: left;
    	max-width: 250px;
      overflow: hidden;
      line-height: 56px;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size:14px;
      font-weight:400;
      color:rgba(255,255,255,1);
      margin-left: 30px;
    }
    .tab_list{
      float: right;
      margin-right: 15px;
      ul{
        display: flex;
        margin-top: 14px;
        li{
          width: 60px;
          height: 28px;
          font-size:14px;
          font-weight:400;
          color:rgba(255,255,255,1);
          box-sizing: border-box;
          border-radius: 4px;
          text-align: center;
          line-height: 28px;
          cursor: pointer;
        }
        .active{
          border: 1px solid #fff;
        }
      }
    }
    .login-user {
      float: right;
      position: relative;
      cursor: pointer;
      .login-name {
        margin-left: 6px;
        color: #fff;
        line-height: 20px;
      }
      .user-name {
        height: 56px;
        display: flex;
        align-items: center;
        .imgBox {
          width: 30px;
          height: 30px;
          text-align: center;
          line-height: 30px;
          border: 1px solid #333;
          border-radius: 50%;
          img{
            height: 100%;
          }
        }
      }
      .el-dropdown {
        margin-right: 22px;
      }
      &:hover{
        .login-name {
          color: #333;
        }
      }
    }
    .tab_list_preview{
      float: right;
      width: 60px;
      height: 28px;
      font-size:14px;
      font-weight:400;
      color:rgba(255,255,255,1);
      box-sizing: border-box;
      border-radius: 4px;
      text-align: center;
      line-height: 28px;
      cursor: pointer;
      border: 1px solid #fff;
      margin-right: 20px;
      margin-top: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/header.vue